import { __awaiter } from "tslib";
/**
 * 发起争议处理
 */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import API from '@/services';
const directCityList = ['北京市', '重庆市', '天津市', '上海市'];
export default createStore({
    state: {
        carPositionList: [],
        isLoading: false,
    },
    effects: {
        getProvince(params, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                console.log('getProvince');
                // FixMe 加载下拉数据
                API.base.getPositionProvince({})
                    .then((data) => {
                    const provinceData = data.map((v) => {
                        v.value = v.soucheProviceCode;
                        v.label = v.provinceName;
                        v.isLeaf = false;
                        return v;
                    });
                    this.SET_STATE({
                        carPositionList: provinceData,
                    });
                });
            });
        },
        getCity({ province, precision }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const carPositionList = JSON.parse(JSON.stringify(state.carPositionList));
                if (carPositionList.length === 0) {
                    setTimeout(() => {
                        this.getCity({
                            province,
                            precision,
                        });
                    });
                }
                else {
                    let needRequest = true;
                    const loadingData = carPositionList.map((v) => {
                        if (v.soucheProviceCode === province[0].soucheProviceCode) {
                            if (v.children) {
                                needRequest = false;
                            }
                            v.loading = true;
                        }
                        return v;
                    });
                    // FixMe 加载下拉数据
                    if (needRequest && !state.isLoading) {
                        !state.isLoading && API.base.getPositionCity({
                            code: province[0].soucheProviceCode,
                        })
                            .then((data) => {
                            const cityData = data.map((v) => {
                                v['value'] = v.soucheCityCode;
                                v['label'] = v.cityName;
                                return v;
                            });
                            const provinceCityData = carPositionList.map((v) => {
                                if (v.soucheProviceCode === province[0].soucheProviceCode) {
                                    const isDirect = directCityList.includes(v.provinceName);
                                    const canPrecision = precision === 'city';
                                    v.children = (isDirect || canPrecision) ? cityData : [{
                                            value: '',
                                            label: '全省',
                                        }, ...cityData];
                                    v.loading = false;
                                }
                                return v;
                            });
                            this.SET_STATE({
                                carPositionList: provinceCityData,
                            });
                        })
                            .catch((err) => {
                            notification.error({
                                message: `${province[0].provinceName ? province[0].provinceName : '省份'}下属地市信息查询失败`,
                                description: '请重试',
                            });
                        })
                            .finally(() => {
                            this.SET_STATE({
                                isLoading: false,
                            });
                        });
                        this.SET_STATE({
                            carPositionList: loadingData,
                            isLoading: true,
                        });
                    }
                }
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
